/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function () {
    'use strict';

    var NewsSearch = /** @class */ (function () {
        function NewsSearch(wrap, form, url) {
            this.wrap = wrap;
            this.form = form;
            this.url = url;
            this.q = form.querySelector('#newsSearchQ');
            this.results = form.querySelector('.results');
        }
        NewsSearch.prototype.init = function () {
            this.initForm();
            this.initInput();
            this.wrap.classList.add('inited');
        };
        NewsSearch.prototype.initInput = function () {
            var _this = this;
            var timeout;
            this.q.addEventListener('keyup', function (e) {
                e.preventDefault();
                clearTimeout(timeout);
                timeout = window.setTimeout(function () {
                    _this.search(_this.q.value);
                }, 500);
            });
        };
        NewsSearch.prototype.initForm = function () {
            var _this = this;
            this.form.setAttribute('action', this.url);
            this.form.addEventListener('submit', function (e) {
                _this.onSubmit(e);
            });
        };
        NewsSearch.prototype.onSubmit = function (e) {
            e.preventDefault();
        };
        NewsSearch.prototype.search = function (q) {
            var _this = this;
            this.clearResults();
            if (q !== '*' && q.length < 3) {
                this.wrap.classList.remove('searching');
                return;
            }
            this.q.style.cursor = 'wait';
            var url = this.url + '?q=' + q + '&t=news';
            fetch(url)
                .then(function (response) { return response.json(); })
                .then(function (json) { return _this.createResultItems(json); })
                .then(function (resultItems) { return _this.filterHeaders(resultItems); })
                .then(function (resultItems) {
                _this.q.style.cursor = 'auto';
                _this.showResults(resultItems);
            })
                .catch(function (error) {
                _this.q.style.cursor = 'auto';
                console.log(error);
            });
        };
        NewsSearch.prototype.clearResults = function () {
            while (this.results.firstChild) {
                this.results.removeChild(this.results.firstChild);
            }
        };
        // noinspection JSMethodCanBeStatic
        NewsSearch.prototype.createResultItems = function (json) {
            return json;
        };
        NewsSearch.prototype.showResults = function (resultItems) {
            var _this = this;
            this.wrap.classList.add('searching');
            if (resultItems.length < 1) {
                this.showEmptyResults();
                return;
            }
            resultItems.forEach(function (item) {
                _this.results.append(_this.createResultElement(item));
            });
        };
        // noinspection JSMethodCanBeStatic
        NewsSearch.prototype.filterHeaders = function (resultItems) {
            return resultItems.filter(function (item) {
                return item.header !== true;
            });
        };
        NewsSearch.prototype.showEmptyResults = function () {
            this.results.append(this.getEmptyResultElement());
        };
        NewsSearch.prototype.getEmptyResultElement = function () {
            if (!this.emptyElement) {
                this.emptyElement = document.createElement('div');
                this.emptyElement.textContent = this.wrap.dataset['notfound'] || 'Ekkert fannst';
                this.emptyElement.classList.add('emptyResults');
            }
            return this.emptyElement.cloneNode(true);
        };
        NewsSearch.prototype.createResultElement = function (item) {
            var el = document.createElement('div');
            el.classList.add('item');
            el.innerHTML = this.renderResultItem(item);
            return el;
        };
        // noinspection JSMethodCanBeStatic
        NewsSearch.prototype.renderResultItem = function (item) {
            var date = item.value.date;
            if (!date) {
                date = '';
            }
            return "\n<div class=\"wrap\">\n\t<div class=\"content\">\n\t\t<h3><a href=\"" + item.value.url + "\">" + item.label + "</a></h3>\n\t\t<div class=\"date\">" + date + "</div>\n\t</div>\n</div>\n";
        };
        return NewsSearch;
    }());

    function newsSearch () {
        var wrap = document.querySelector('#newsSearch');
        if (wrap instanceof HTMLElement) {
            var form = wrap.querySelector('form');
            if (form) {
                var url = form.dataset['action'];
                if (url) {
                    var ns = new NewsSearch(wrap, form, url);
                    ns.init();
                }
            }
        }
    }

    return newsSearch;

}());
typeof tsBuild === 'function' && tsBuild();})();
